<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.909091"
      y="0.909091"
      width="26.1818"
      height="26.1818"
      rx="13.0909"
      stroke="#D1D5DB"
      stroke-width="1.81818"
    />
    <path
      d="M12.2291 7.90909C12.2291 8.87273 13.0291 9.65455 13.9746 9.65455C14.9746 9.65455 15.7564 8.87273 15.7564 7.90909C15.7564 6.92727 14.9746 6.14545 13.9746 6.14545C13.0291 6.14545 12.2291 6.92727 12.2291 7.90909ZM15.4291 21H12.5746V11.2909H15.4291V21Z"
      fill="#9CA3AF"
    />
  </svg>
</template>
